import { JoonUIColor, SPACING } from "@joonapp/web-shared"
import * as DropdownMenu from "@radix-ui/react-dropdown-menu"
import React, { useState } from "react"

import "./dropdown.scss"

interface DropdownItem {
  label: string
  onClick: () => void
}

interface DropdownProps {
  trigger: React.ReactNode
  items: DropdownItem[]
  position?: DropdownMenu.DropdownMenuContentProps["side"]
  align?: DropdownMenu.DropdownMenuContentProps["align"]
  onOpenChange?: (open: boolean) => void
}

const Dropdown: React.FC<DropdownProps> = ({
  trigger,
  items,
  position = "bottom",
  align = "start",
  onOpenChange,
}) => (
  <DropdownMenu.Root onOpenChange={onOpenChange}>
    <DropdownMenu.Trigger>{trigger}</DropdownMenu.Trigger>
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        side={position} // Position the dropdown below the trigger
        align={align} // Align the dropdown to the start of the trigger
        sideOffset={5}
        className="DropdownMenuContent"
        style={{
          backgroundColor: "white",
          borderRadius: SPACING.space2,
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          zIndex: 1000,
          minWidth: "150px",
          overflow: "hidden",
          border: `1px solid ${JoonUIColor.border.default}`,
        }}
      >
        {items.map((item, index) => (
          <DropdownMenuItem
            key={index}
            item={item}
            isLastItem={index === items.length - 1}
          />
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  </DropdownMenu.Root>
)

const DropdownMenuItem = ({
  item,
  isLastItem,
}: {
  item: DropdownItem
  isLastItem: boolean
}) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <DropdownMenu.Item
      onSelect={item.onClick}
      style={{
        padding: `${SPACING.space3} ${SPACING.space4}`,
        cursor: "pointer",
        borderBottom: isLastItem
          ? "none"
          : `1px solid ${JoonUIColor.border.default}`,
        backgroundColor: isHovered
          ? JoonUIColor.background.xlightGray
          : "white",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {item.label}
    </DropdownMenu.Item>
  )
}

export default Dropdown
